import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';

@Component({
  selector: 'app-biens-comparables-vendus',
  templateUrl: './biens-comparables-vendus.component.html',
  styleUrls: ['./biens-comparables-vendus.component.scss'],
})
export class BiensComparablesVendusComponent {
  @Input() references!: Report.References;
  @Input() isLoading = false;
  @Input() reportType!: string;

  referencesInternal!: Report.References;

  @Output() referencesChanged = new EventEmitter<Report.References>();
  @Output() referencesEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  onReferencesChanged(referencesInternal: Report.References): void {
    this.referencesInternal = referencesInternal;
  }

  onSaveSection(): void {
    this.referencesChanged.emit(this.referencesInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.referencesEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
